(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("layer-reprojection", [], factory);
	else if(typeof exports === 'object')
		exports["layer-reprojection"] = factory();
	else
		root["layer-reprojection"] = factory();
})(self, function() {
return 